import { useEffect } from 'react';

export default function Job(){
    useEffect(() => {
        window.location.href = '/';
    }, []);
    
    return null;
}